import React, { MouseEvent, useCallback } from 'react';
import { ClickableParams } from './types';

const Link = ({ cssName, onClick, children }: ClickableParams): JSX.Element => {
    const handleClick = useCallback(
        (e: MouseEvent): void => {
            e.stopPropagation();
            e.preventDefault();
            onClick();
        },
        [onClick],
    );

    return (
        <a
            className={cssName}
            onClick={handleClick}
        >
            {children}
        </a>
    );
};

export default Link;
